import { Module } from 'vuex'
import state from './state'
import * as getters from './getters'
import { actions } from './actions'
import * as mutations from './mutations'
import { RootState } from '../types'
import { ContentState } from './types'

const namespaced = true

export const content: Module<ContentState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
